module.exports = __webpack_public_path__ + "img/fuli-propa.b71630f1.png";